<template>
  <div>
    
    <itprojdetails-tour v-if="$store.state.tour & !loading" />

    <transition name="menu-popover">
      <div v-if="overlay" class="lightbox">
        <h2 class="closeX" @click="closeLightbox">
          <a>&#215;</a>
        </h2>
        <div>
      <div
    class="align-items-center p-3 mt1r rounded bs-shadow decision-card"
    style="
      background: #fff;
      padding: 20px;
      display: block;
      position: relative;
    "
  >
    <h2
      @click="closeLightbox"
      style="
        position: absolute;
        right: 10px;
        top: 4px;
        cursor: pointer;
        line-height: 1;
        z-index: 1000;
      "
    >
      &#215;
    </h2>

    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-12">
          <h6 style="text-align: center">Approve or Deny Project</h6>

          <hr />

          <div class="w100">
            <div class="top-wrap">
              <div class="dflex mb10" v-if="firstName && lastName">
                <!--
                 <avatar
                  v-once
                  class="mr5"
                  color="#fff"
                  v-bind:username="firstName + ' ' + lastName"
                  v-bind:backgroundColor="
                    colorGetter[Math.floor(Math.random() * colorGetter.length)]
                  "
                ></avatar>
                -->
               

                <div class="dflex vcenter">
                  <div style="text-align: left">
                    <h6 class="mb0">
                      <b>{{ firstName }} {{ lastName }}</b>
                    </h6>
                    <p class="lh1 mb0" style="max-width: 150px">
                      <small>{{ company }}</small>
                    </p>
                  </div>
                </div>
              </div>
              <div class="mlauto dflex vcenter">
                <p class="lh1 mb0"></p>
              </div>
            </div>
          </div>


          <form class="w100" style="margin-bottom: 0">
            <div class="form-group mb-0">
              <div class="form-group">
                <textarea
  class="form-control custom-textarea"
  id="exampleFormControlTextarea1"
  rows="10"
  v-model="decisionReason"
  :placeholder="`${$store.state.user.FirstName}, please provide a reason for your decision on this project. If a project is denied, a reason is required. We will notify ${project.submitterAC} of your decision.`"
  style="
    padding: 15px;
    width: 100%;
    border-radius: 4px;
    border: none;
    background: #e6edf2;
    color: #000;
  "
></textarea>
              </div>
            </div>
            <div style="display: flex; align-items: center;">
              <div class="custom-control custom-radio" style="margin-right: 15px;">
                  <input
                    type="radio"
                    id="rd_2"
                    name="rd"
                    class="custom-control-input"
                    value="Approved"
                    v-model="decision"
                  />
                  <label class="custom-control-label red" for="rd_2"
                    >Approve</label
                  >
                </div>
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="rd_1"
                    name="rd"
                    class="custom-control-input"
                    value="Denied"
                    v-model="decision"
                  />
                  <label class="custom-control-label green" for="rd_1"
                    >Deny</label
                  >
                </div>
                </div>
 <button
                 v-if="(decision == 'Denied' && !decisionReason) || loading"
                  disabled
                  class="list-btn"
                  style="align-items: center; display: flex; margin-left: auto; border: none; padding: 5px 10px; line-height: 1.5;"
            >
              Submit
            </button>
                 <button
                 v-else
                 @click.prevent="ApproveOrDeny"
                  class="list-btn"
                  style="align-items: center; display: flex; margin-left: auto; border: none; padding: 5px 10px; line-height: 1.5;"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>

    <!-- #################### end first row ###################### -->
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-12">
         
        </div>
      </div>
    </div>
  </div>
  </div>
        
      </div>
    </transition>
    
    <section
      v-if="loading && !project"
      class="py-5 bg9 bs-shadow mobile-top"
      style="min-height: 194px"
    >
      <div class="container">
        <h1 class="text-white mb0 lh1">Loading Project....</h1>
        <br />
        <div class="hollow-dots-spinner">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </section>

    <section v-else class="py-5 bg9 bs-shadow mobile-top">
      <div class="container">
        <h1 v-if="project && project.projName" class="text-white mb0 lh1">
          {{ project.projName }}
        </h1>
        <h2 v-if="project && project.id" class="text-white lh1">
          {{ "Project #" + project.id }}
        </h2>
        <p v-if="project && project.projName" class="text-white lh1 mb0">
          {{ project.projDescription }}
        </p>
      </div>
    </section>

    <div v-if="loading || !project" class="row">
      <div class="col-xs-12 col-sm-12 col-12 col-lg-12">
        <div class="flex-box-wrap">
          <div class="flex-internal">
            <atom-spinner
              :animation-duration="1000"
              :size="40"
              :color="'#575757'"
            />
            <p>Loading......</p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="container mt30 mb20">
      <!-- col -->
      <div class="row">
        <div class="col-lg-8">

          <!-- Start Approval -->
      
          <div v-if="project" class="card-back mb10 rounded bs-shadow p-3">
            <div class="d-flex number-showing">
              <BackButton />

              
               <button
                    v-if="(this.project.installationACID == this.userCompany) && !this.project.approverFullName.length"
                    @click="showOverlay()"
                    class="mb10 lh1 mlauto list-btn"
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      padding: 5px 10px;
                    "
                    >Approve / Deny
                    
                   
                  </button
                  >
            
                  <!--
              <button
                    v-if="this.project.installationACID == this.userCompany"
                    @click="showOverlay()"
                    class="mb10 lh1 mlauto list-btn"
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      padding: 5px 10px;
                    "
                    >Approve / Deny
                    
                   
                  </button
                  >
                    -->
              </div>
            
            <h4 style="margin-top: 10px;">Partner Project Approval</h4>
            <hr/>
          
                  <h6 class="mt20" style="display: flex; align-items: center;">
<svg xmlns="http://www.w3.org/2000/svg" style="margin-right: 5px;" enable-background="new 0 0 24 24" height="20px" viewBox="0 0 24 24" width="20px" fill="#575757"><rect fill="none" height="20" width="20"/><path d="M18.6,19.5H21v2h-6v-6h2v2.73c1.83-1.47,3-3.71,3-6.23c0-4.07-3.06-7.44-7-7.93V2.05c5.05,0.5,9,4.76,9,9.95 C22,14.99,20.68,17.67,18.6,19.5z M4,12c0-2.52,1.17-4.77,3-6.23V8.5h2v-6H3v2h2.4C3.32,6.33,2,9.01,2,12c0,5.19,3.95,9.45,9,9.95 v-2.02C7.06,19.44,4,16.07,4,12z M16.24,8.11l-5.66,5.66l-2.83-2.83l-1.41,1.41l4.24,4.24l7.07-7.07L16.24,8.11z"/></svg>                    <span style="margin-right: 5px;"> Status</span> 
                    
                
                  </h6>
                  <p class="text-muted mb5 lh1">
                    <small v-if="project.status">
                      {{ project.status }}
                    </small>
                    <small v-else>n/a</small>
                  </p>
                  <h6 class="mt20" style="display: flex; align-items: center;">

                    <span class="material-icons" style="font-size:18px">person</span><span style="margin-left: 5px;"> Decided By</span> 
                    
                
                  </h6>
               
                  <!--
                   <p class="text-muted mb5 lh1">
                    <small v-if="project.leadSalesPersonFullName">
                      Approved
                    </small>
                    <small v-else>n/a</small>
                  </p>

                  <h6 class="mt20" style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">calendar_month</span><span style="margin-left: 5px;"> Date</span> 
                    
                
                  </h6>
                  -->
                 


                  <p class="text-muted mb5 lh1">
                    <small v-if="project?.approverFullName">
                      {{ project.approverFullName }}
                    </small>
                    <small v-else>n/a</small>
                  </p>
                  <h6 class="mt20" style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> Notes</span> 
                    
                
                  </h6>
                  <p class="text-muted mb5 lh1">
                    <small v-if="project.statusExplanation">
                      {{ project.statusExplanation }}
                      
                    </small>
                    <small v-else>n/a</small>
                  </p>

                              <!-- contact -->

            <h6 class="mt20" style="display: flex; align-items: center;">
              <span class="material-icons" style="font-size:18px">person</span><span style="margin-left: 5px;"> Primary Contact</span>     
            </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.primaryContact">
                {{ project.primaryContact }}
              </small>
              <small v-else>n/a</small>
            </p>

            <h6 class="mt20" style="display: flex; align-items: center;">
              <span class="material-icons" style="font-size:18px">calendar_month</span><span style="margin-left: 5px;"> Date of Conversation</span>     
            </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.conversationDate">
                {{
                      $moment(project.conversationDate).format("MM-DD-YYYY")
}}

              </small>
              <small v-else>n/a</small>
            </p>
          </div>
    
          <!-- End Approval -->
          <div
            id="itprojdetails-step-1"
            class="card-back mb10 rounded bs-shadow p-3"
          >
            <div class="question-header d-flex align-items-center mb5 rounded">

<!--
    <div class="d-flex number-showing">
              <BackButton />

              </div>           
-->
             

              <div class="pag-wrapper mlauto">
                <h2>{{ project.requestReason }}</h2>
              </div>
            </div>
            <!--
            <hr />
            -->
            
            <div class="info-top">
              
              <div class="">
                <div v-if="project">
                  

                
                 <div style="display: flex;">
                  <h4>Job Information</h4>
                  <div class="status ml" style="margin-left: auto">
                  <p v-if="project.sscNetValue" class="badge badge-success" style="padding:10px!important; margin-bottom: 0;">
                    Net Value: {{ formatPrice(project.sscNetValue) }}
                  </p>
                  <p v-else class="badge badge-success">Net Value: n/a</p>
                </div>
                </div>
                  <hr/>
                  <h6 class="mt20" style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">person</span><span style="margin-left: 5px;"> Lead Sales Person</span> 
                
                  </h6>
                  <p class="text-muted mb5 lh1">
                    <small v-if="project.leadSalesPersonFullName">
                      {{ project.leadSalesPersonFullName }}
                    </small>
                    <small v-else>n/a</small>
                  </p>

                  <h6 class="mt20" style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">person</span><span style="margin-left: 5px;"> Submitted By</span> 
                  </h6>
                  <p class="text-muted mb5 lh1">
                    <small v-if="project.submitterFullName">
                      {{ project.submitterFullName }}
                    </small>
                    <small v-else>n/a</small>
                  </p>
                </div>
                
              </div>

              <h6 class="mt20" style="display: flex; align-items: center;">
               
                <span class="material-icons" style="font-size:18px">corporate_fare</span><span style="margin-left: 5px;"> Area Contractor Submitted</span> 
              </h6>
              <p class="text-muted mb5 lh1">
                <small v-if="project.submitterAC" class="text-muted">
                  {{ project.submitterAC }}
                </small>
                <small v-else class="text-muted">n/a</small>
              </p>

              <h6 class="mt20" style="display: flex; align-items: center;">             
                <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> Market</span> 
              </h6>
              <p class="text-muted mb5 lh1">
                <small v-if="project.marketID" class="text-muted">
                  {{ project.marketID }}
                </small>
                <small v-else class="text-muted">n/a</small>
              </p>
              <h6 class="mt20" style="display: flex; align-items: center;">
                <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> Products</span> 
              </h6>
              <p
                class="text-muted mb10"
                v-for="(part, index) in project.itjobProducts"
                :key="index"
              >
                <small v-if="project.projDescription" class="lh1">
                  {{ part.productId }}
                </small>
                <small v-else class="lh1">n/a</small>
              </p>
              <h6 class="mt20" style="display: flex; align-items: center;">
                <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> Project Explanation</span>
              </h6>
              <p class="text-muted mb20">
                <small v-if="project.projDescription" class="lh1">
                  {{ project.projDescription }}
                </small>
                <small v-else class="lh1">n/a</small>
              </p>
            </div>
          </div>

          <!-- new card -->
          <div
            id="itprojdetails-step-3"
            class="card-back mb10 rounded bs-shadow p-3"
          >
            <h4>Installation Information</h4>
            <hr />
            <h6 style="display: flex; align-items: center;">
              <span class="material-icons" style="font-size:18px">corporate_fare</span><span style="margin-left: 5px;"> Installation AC</span> 
            
            </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.installerAC">
                {{ project.installerAC }}
              </small>
              <small v-else>n/a</small>
            </p>
           
            <h6 class="mt20" style="display: flex; align-items: center;">             
                <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> Note to AC</span> 
              </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.installNotes" class="text-muted">
                {{ project.installNotes }}
              </small>
              <small v-else class="text-muted">n/a</small>
            </p>
          </div>

          <!-- new card -->
          <div
            id="itprojdetails-step-4"
            class="card-back mb10 rounded bs-shadow p-3"
          >
            <h4>End User/Customer Information</h4>
            <hr />
            <h6 style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">person</span><span style="margin-left: 5px;"> Customer Contact Name</span> 
                
                  </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.endUserName">
                {{ project.endUserName }}
              </small>
              <small v-else>n/a</small>
            </p>

            <h6 class="mt20" style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">phone</span><span style="margin-left: 5px;"> Customer Phone</span> 
                
                  </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.endUserPhone">
                {{ project.endUserPhone }}
              </small>
              <small v-else>n/a</small>
            </p>
            <h6 class="mt20" style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">email</span><span style="margin-left: 5px;"> Customer Email</span> 
                
                  </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.endUserEmail">
                {{ project.endUserEmail }}
              </small>
              <small v-else>n/a</small>
            </p>
            
            <h6 class="mt20" style="display: flex; align-items: center;">
              <span class="material-icons" style="font-size:18px">corporate_fare</span><span style="margin-left: 5px;"> Contact Company</span> 
            
            </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.endUserCompany" class="text-muted">
                {{ project.endUserCompany }}
              </small>
              <small v-else class="text-muted">n/a</small>
            </p>
            <p class="text-muted mb5 lh1">
              <small v-if="project.endUserStreet" class="text-muted">
                {{ project.endUserStreet + " " }}
              </small>
              <small v-if="project.endUserCity" class="text-muted">
                {{ project.endUserCity + ", " }}
              </small>
              <small v-if="project.endUserState" class="text-muted">
                {{ project.endUserState + " " }}
              </small>
              <small v-if="project.endUserZip" class="text-muted">
                {{ project.endUserZip }}
              </small>
            </p>
          </div>

          <!-- new card -->
          <div
            id="itprojdetails-step-5"
            class="card-back mb10 rounded bs-shadow p-3"
          >
            <h4>General Contractor Information</h4>
            <hr />


            <h6 style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">person</span><span style="margin-left: 5px;"> Contractor Name</span> 
                
                  </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.contractorName">
                {{ project.contractorName }}
              </small>
              <small v-else>n/a</small>
            </p>
            <h6 class="mt20" style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">phone</span><span style="margin-left: 5px;"> Contractor Phone</span> 
                
                  </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.contractorPhone">
                {{ project.contractorPhone }}
              </small>
              <small v-else>n/a</small>
            </p>

            <h6 class="mt20" style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">email</span><span style="margin-left: 5px;"> Contractor Email</span> 
                
                  </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.contractorEmail">
                {{ project.contractorEmail }}
              </small>
              <small v-else>n/a</small>
            </p>
            
            <h6 class="mt20" style="display: flex; align-items: center;">
              <span class="material-icons" style="font-size:18px">corporate_fare</span><span style="margin-left: 5px;"> Contractor Company</span> 
            
            </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.contractorCompany">
                {{ project.contractorCompany }}
              </small>
              <small v-else>n/a</small>
            </p>
            <p class="text-muted mb5 lh1">
              <small v-if="project.contractorStreet" class="text-muted">
                {{ project.contractorStreet + " " }}
              </small>

              <small v-if="project.contractorCity" class="text-muted">
                <br />
                {{ project.contractorCity + ", " }}
              </small>

              <small v-if="project.contractorState" class="text-muted">
                {{ project.contractorState + " " }}
              </small>
              <small v-if="project.contractorZip" class="text-muted">
                {{ project.contractorZip + " " }}
              </small>
              <small v-if="project.contractorCounty" class="text-muted">
                {{ project.contractorCounty + " " }}
              </small>
              <!--
              <small v-else class="text-muted">n/a</small>
              -->
            </p>
          </div>

          <!-- new card -->
          <div
            id="itprojdetails-step-6"
            class="card-back mb10 rounded bs-shadow p-3"
          >
            <h4>Architect Information</h4>
            <hr />
            <h6 style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">person</span><span style="margin-left: 5px;"> Architect Name</span> 
                
                  </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.architectName">
                {{ project.architectName }}
              </small>
              <small v-else>n/a</small>
            </p>

            <h6 class="mt20" style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">phone</span><span style="margin-left: 5px;"> Architect Phone</span> 
                
                  </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.architectPhone">
                {{ project.architectPhone }}
              </small>
              <small v-else>n/a</small>
            </p>
            <h6 class="mt20" style="display: flex; align-items: center;">
                    <span class="material-icons" style="font-size:18px">email</span><span style="margin-left: 5px;"> Architect Email</span> 
                
                  </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.architectEmail">
                {{ project.architectEmail }}
              </small>
              <small v-else>n/a</small>
            </p>
           
            <h6 class="mt20" style="display: flex; align-items: center;">
              <span class="material-icons" style="font-size:18px">corporate_fare</span><span style="margin-left: 5px;"> Architect Company</span> 
            
            </h6>
            <p class="text-muted mb5 lh1">
              <small v-if="project.architectCompany">
                {{ project.architectCompany }}
              </small>
              <small v-else>n/a</small>
            </p>
            <p class="text-muted mb5 lh1">
              <small v-if="project.architectStreet" class="text-muted">
                {{ project.architectStreet + " " }}
              </small>
              <br />
              <small v-if="project.architectCity" class="text-muted">
                {{ project.architectCity + ", " }}
              </small>

              <small v-if="project.architectState" class="text-muted">
                {{ project.architectState + " " }}
              </small>
              <small v-if="project.architectZip" class="text-muted">
                {{ project.architectZip }}
              </small>
              <!--
              <small v-else class="text-muted">n/a</small>
              -->
            </p>
          </div>
        </div>
        <div class="col-lg-4">
          <div
            id="itprojdetails-step-2"
            class="card-back mb10 rounded bs-shadow p-3"
          >
            <ul class="list-group mb-3">
              <li
                class="
                  list-group-item
                  d-flex
                  justify-content-between
                  lh-condensed
                "
              >
                <div>
                 

                  <h6 class="my-0" style="display: flex; align-items: center;">             
                <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> Project ID</span> 
              </h6>

                  <div>
                    <small class="text-muted">{{ project.id }}</small>
                  </div>
                </div>
                <!--
                <span class="text-success">-$5</span>
                -->
              </li>
              <li
                class="
                  list-group-item
                  d-flex
                  justify-content-between
                  lh-condensed
                "
              >
                <div>
                 
                  <h6 class="my-0" style="display: flex; align-items: center;">             
                <span class="material-icons" style="font-size:18px">calendar_month</span><span style="margin-left: 5px;"> Order Date (est)</span> 
              </h6>

                  <div>
                    <small class="text-muted">{{
                      $moment(project.orderDate).format("MM-DD-YYYY")
                    }}</small>
                  </div>
                </div>
                <!--
                <span class="text-success">-$5</span>
                -->
              </li>
              <li
                class="
                  list-group-item
                  d-flex
                  justify-content-between
                  lh-condensed
                "
              >
                <div>
               
                  <h6 class="my-0" style="display: flex; align-items: center;">             
                <span class="material-icons" style="font-size:18px">calendar_month</span><span style="margin-left: 5px;"> Ship Date (est)</span> 
              </h6>
                  <small class="text-muted">{{
                    $moment(project.shipDate).format("MM-DD-YYYY")
                  }}</small>
                </div>
                <!--
                <span class="text-muted">$12</span>
                -->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
// import Avatar from "vue-avatar";
import itprojdetailsTour from "../components/Tours/itprojdetailsTour.vue";
import { formatCurrency } from '../utils/utils';
import BackButton from '@/components/Buttons/BackButton.vue';
import Avatar from '../components/Atoms/Avatar.vue'
import { jwtDecode } from 'jwt-decode';


const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
  },
};

export default {
  name: "InterterritorialDetails",
  components: {
    AtomSpinner,
    BackButton,
    // Avatar,
    itprojdetailsTour,
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      server: import.meta.env.VITE_APP_SERVER_URL,
      projectId: this.$route.params.id,
      userCompany: null,
      project: null,
      loading: false,
      processing: false,
      preprod: false,
      inprod: false,
      shipped: false,
      open: "",
      pdfPreview: "",
      overlay: false,
      decisionReason: "",
      decision: "Accepted",
      userID: this.$store.state.user.UserId,
      fullName:
        this.$store.state.user.FirstName +
        " " +
        this.$store.state.user.LastName,
      UserFirstName: this.$store.state.user.FirstName,
      UserLastName: this.$store.state.user.LastName,
      submitterEmail: '',
      salesRepEmail: '',
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.$store.commit("setActivePage", "order-manage");
      //return axios.get(this.endPointCompute, auth).then((response) => {
      return axios
        .get(`${this.ordermanageapi}/itproj/${this.projectId}`, auth)
        .then((response) => {
          
        if (response.status === 401) {
            this.$router.push("/");
        } else {
          console.log(response);
          this.project = response.data.projDetails[0];
          this.submitterEmail = this.project?.submitterEmail;
          this.salesRepEmail = this.project?.leadSalesPersonEmail;
          this.loading = false;
          document
            .getElementById("mobileScrollTarget")
            .scrollIntoView({ behavior: "smooth" });
        }         
        });
    },
    showOverlay() {
      this.overlay = true;
    },
    closeLightbox() {
      this.overlay = false;
    },
    async ApproveOrDeny() {
      this.loading = true;

      const payload = {
        Status: this.decision,
        StatusExplanation: this.decisionReason,
        Approver: this.userID
      };

      try {
        // update project status
        const updateResponse = await axios.post(
          `${this.ordermanageapi}/itproj/${this.projectId}`,
          payload,
          auth
        );

        this.project = updateResponse.data.projDetails[0];

        // Email Notification
        try {

          const emailPayload = {
            projectId: this.projectId,
            projectName: this.project.projName,
            status: this.decision,
            statusExplanation: this.decisionReason || null,
            approverName: this.project.approverFullName,
            approverEmail: this.project.approverEmail,
            // submitterEmail: 'joas@spacesaver.com',
            leadSalesRepEmail: 'spacenet3feedback@spacesaver.com',
            submitterEmail: this.project.submitterEmail,
            // leadSalesRepEmail: this.project.leadSalesPersonEmail
          };

          const emailResponse = await axios.post(
            `${this.server}/api/v1/send-itproject-notification`, 
            emailPayload,
            auth
          );

          const sentCount = emailResponse.data.sentTo?.length || 0;
          const recipients = emailResponse.data.sentTo?.join(', ') || '';

          this.$toast.success(
            `Project ${this.decision.toLowerCase()}:  ` +
            (sentCount > 0
              ? `Notification sent`
              : 'Notification queued')
          );

        } catch (emailError) {
          console.warn('Email notification failed (non-blocking):', emailError.response?.data || emailError);
          this.$toast.warning(
            `Project updated successfully, but email notification failed. ` +
            (emailError.response?.data?.error || '')
          );
        }

        // Smooth scroll
        this.$nextTick(() => {
          const el = document.getElementById("mobileScrollTarget");
          if (el) el.scrollIntoView({ behavior: "smooth" });
        });

      } catch (error) {
        console.error("Failed to update project:", error);
        this.$toast.error(
          error.response?.data?.error || "Failed to update project status"
        );
      } finally {
        this.loading = false;
        this.overlay = false;
      }
    },
    formatPrice(amount) {
      return formatCurrency(amount);
    },
    makeActive(item) {
      //console.log(item);
      if (this.open === item) {
        this.open = "";
      } else {
        this.open = item;
      }
    },
    UserCompanyGetter() {
      let number = this.$store.state.user.CompanyID;
      let UserID = this.$store.state.user.UserId;
      console.log("number " + number);
      console.log("user " + UserID)
      this.userCompany = number;
    },
    
  },
  computed: {
    
    activeNav() {
      return this.$store.state.activePage;
    },

    colorGetter() {
      return this.$store.state.colors;
    },

    getUsername() {
      return this.$store.state.user;
    },
  },
  created() {
    this.$store.commit("showNavigation");


    // console.log(this.$route.path);
  },
  mounted() {
    document
      .getElementById("mobileScrollTarget")
      .scrollIntoView({ behavior: "smooth" });
    this.firstLoad().then(function () {});
    this.UserCompanyGetter();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all and (min-width: 992px) {
  .flex-box-wrap {
    height: 200px;
    padding: 150px 0 125px 0;
    margin: 0;
  }
}

@media all and (max-width: 991px) {
  .flex-box-wrap {
    height: 100px;
    padding: 75px 0 50px 0;
    margin: 0;
    justify-content: center;
    align-items: center;
  }
}

.card-back {
  background: #fff;
}
.article {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.question-bottom {
  align-items: flex-end;
}
.question-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.center {
  align-items: center;
  justify-content: center;
}
.tab-container {
  background: #f2f2f3;
  padding: 10px;
  border-radius: 4px;
}
.nav-tabs {
  border-bottom: none;
}
.nav-tabs .nav-link {
  border: none;
}
#nav-tabContent {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}
.d-flex {
  display: flex;
}
.ml {
  margin-left: auto;
}
/*
.comments:nth-child(even) {
  background: #efefef;
  padding: 10px;
  margin-bottom: 1rem;
  border-radius: 4px;
}
*/
.comments {
  border-bottom: 1px solid #efefef;
  margin-bottom: 10px;
}
.comments p {
  margin-bottom: 10px;
}
.comments:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.comments:last-child p {
  margin-bottom: 0;
}
.tab-container a {
  color: #429da8;
}
.mt30 {
  margin-top: 30px;
}
.badge {
  display: inline-block;
  padding: 0.5em 0.8em;
}
.progtrckr {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.progtrckr li {
  display: inline-block;
  text-align: center;
  line-height: 3.5em;
}

.progtrckr[data-progtrckr-steps="2"] li {
  width: 25%;
}
.progtrckr[data-progtrckr-steps="3"] li {
  width: 25%;
}
.progtrckr[data-progtrckr-steps="4"] li {
  width: 25%;
}
.progtrckr[data-progtrckr-steps="5"] li {
  width: 25%;
}

.progtrckr li.progtrckr-done {
  color: #fff;
  border-bottom: 4px solid #fff;
}
.progtrckr li.progtrckr-todo {
  color: #3e4651;
  border-bottom: 4px solid #3e4651;
}

.progtrckr li:after {
  content: "\00a0\00a0";
  margin-left: 28px;
  /* this is the text*/
}
.progtrckr li:before {
  position: relative;
  bottom: -2.5em;
  float: left;
  left: calc(50% - 20px);
  line-height: 1em;
}
.progtrckr li.progtrckr-done:before {
  content: "\2713";
  color: #3e4651;
  background-color: #fff;
  height: 40px;
  width: 40px;
  line-height: 40px;
  border: none;
  border-radius: 40px;
}
.progtrckr li.progtrckr-todo:before {
  /*
  content: "\039F";
  color: #fff;
  background-color: #fff;
  font-size: 2.2em;
  bottom: -1.2em;
  */
  content: "\2713";
  color: #3e4651;
  background-color: #3e4651;
  height: 2.2em;
  width: 2.2em;
  line-height: 2.2em;
  border: none;
  border-radius: 2.2em;
}
/* trackker titles */
.tracker-title-wrap {
  margin-top: 15px;
}
.trckr-title {
  padding-left: 0;
}
.trckr-title li {
  display: inline-block;
  text-align: center;
  line-height: 3.5em;
  width: 25%;
  color: #fff;
}
.trckr-title-done {
  color: #fff !important;
}
.trckr-title-todo {
  color: #3e4651 !important;
}
.badge-success {
  color: #fff;
  background-color: #3e4651;
}
@media all and (max-width: 700px) {
  .trckr-title li {
    font-size: 12px;
  }
}
.up {
  text-transform: uppercase;
}
.lines-table td,
.lines-table th {
  padding: 5px;
}
.small,
small {
  font-size: 90% !important;
}

.table td .small,
small {
  font-size: 90% !important;
}
.bol {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  background: #fff;
  padding: 10px;
  list-style-type: none;
  /*border: 1px solid #dee2e6;*/
  background: #efefef;
  margin-bottom: 5px;
  transition: background 0.8s linear;
  border-radius: 4px;
  cursor: pointer;
}
.bol:hover {
  background: #e6e5e5;
}
.parent {
  display: flex;
  align-items: center;
}
.parent i {
  transition: color 0.8s linear;
}
.parent:hover i {
  color: #000;
}
.parent:hover {
  color: #000;
}
.parent:active i {
  color: #00b4b4;
}
.parent i {
  /*margin-left: auto;*/
}
.child-list {
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  /*transition: height 0.8s linear;*/
  height: 100%;
  max-height: 100%;
  padding: 5px;
  margin-top: 10px;
  border-radius: 4px;
}
.child-list li {
  position: relative;
  list-style-type: none;
  margin-left: 0;
  border-bottom: 1px solid #dedede;
  padding: 5px;
}
.child-list li:last-of-type {
  border-bottom: none;
}
.is-closed {
  max-height: 0;
}
.show {
  height: 100% !important;
  max-height: 100% !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.smooth-enter-active,
.smooth-leave-active {
  transition: opacity 0.5s;
  height: auto;
}
.smooth-enter,
.smooth-leave-to {
  opacity: 0;
}

.height-enter-active,
.height-leave-active {
  transition: height 0.5s;
  height: auto;
}
.height-enter,
.height-leave-to {
  height: 0;
}
.ship-head {
  display: flex;
  width: 100%;
}
.pallet {
  width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ship-number {
  width: calc(50% + 3px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media all and (max-width: 700px) {
  .pallet {
    width: 60%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ship-number {
    width: calc(60% + 3px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.fa-arrow-circle-down {
  margin-left: auto;
}

.w100 {
  width: 100%;
}
.dflex {
  display: flex;
}
.info {
  border-top: 1px solid #dedede;
  padding-top: 5px;
  margin-top: 5px;
}
.truck-no {
  margin-left: -5px;
}
.closeX {
  top: 0;
}
.pdfLink {
  color: #429da8;
  cursor: pointer;
  margin-bottom: 0;
}
.pdfLink:hover {
  color: #00b4b4;
}
.pdfLink:active {
  color: #00b4b4;
}
.lightbox {
  z-index: 10003 !important;
}
 .lightbox {
	/** Default lightbox to hidden */
	/*display: none;
	*/
	/** Position and style */
	 position: fixed;
	 z-index: 1001;
	 width: 100%;
	 height: 100%;
	 text-align: center;
	 top: 0;
	 left: 0;
	 background: rgba(0, 0, 0, 0.4);
	 display: flex !important;
	 align-items: center !important;
	 justify-content: center !important;
}
 .lightbox img {
	/** Pad the lightbox image */
	 max-width: 90%;
	 max-height: 80%;
	 border: 8px solid #fff;
}
 .lightbox .lightbox-vid {
	 width: 90%;
	 max-width: 90%;
	 margin: 0 auto;
	 border: 8px solid #fff;
	 z-index: 1004;
}
 .closeX {
	 color: #fff;
	 font-size: 3em;
	 position: absolute;
	 top: 10px;
	 left: 20px;
	 cursor: pointer;
	 transition: color 0.5s ease;
}
 .closeX:hover {
	 color: #42b983;
}
.custom-radio .custom-control-label::before {
  background-color: #fff;
  border: 1px solid #00c7c7;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #00c7c7;
  border: 1px solid #00c7c7;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::before,
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #00c7c7;
  border-radius: 50%;
}

.custom-control-input:checked ~ .custom-control-label.red::before {
  background-color: none;
}

.custom-control-input:checked ~ .custom-control-label.green::before {
  background-color: #00c7c7;
}

.custom-radio .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none !important;
}

.custom-radio .custom-control-input:active ~ .custom-control-label::before {
  color: #fff;
  background-color: #fff;
}

/*
.custom-control-label {
  padding-left: 20px !important;   =


.custom-control-label::before,
.custom-control-label::after {
  left: 0;                        
}
*/

/* 1. Remove Bootstrap's default left indent */
.custom-control {
  padding-left: 0 !important;        /* kills the 25–30px indent */
  display: flex;    
  align-items: center;                 /* makes inline layout predictable */
}

/* 2. Put the actual radio circle back at the far left */
.custom-control-label::before,
.custom-control-label::after {
  left: 0 !important;
  top: 50%;
  transform: translateY(-50%);
}

/* 3. Pull the text super close to the circle */
.custom-control-label {
  padding-left: 21px !important;      /* ← adjust 6–10px to taste */
  line-height: 1.2;
  cursor: pointer;
}

/* Optional: tiny vertical centering tweak */
.custom-control-input {
  position: absolute;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.decision-card{
  min-width: 450px;
}
textarea::placeholder {
  color: #808080 !important;  /* dark enough to be readable */
  opacity: 1;                 /* some browsers apply lower opacity by default */
}

textarea::-moz-placeholder {
  color: #808080 !important;
  opacity: 1;
}

textarea:-ms-input-placeholder {
  color: #808080 !important;
}
</style>
